import { render } from "./AnfrageButton.vue?vue&type=template&id=3f71e9ad"
import script from "./AnfrageButton.vue?vue&type=script&lang=js"
export * from "./AnfrageButton.vue?vue&type=script&lang=js"

import "./AnfrageButton.vue?vue&type=style&index=0&id=3f71e9ad&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__